import React from 'react';
import { TrafficConeIcon, CalendarDaysIcon, SunIcon } from 'lucide-react';
export function Method() {
  return <section className="py-16 md:py-24 bg-white overflow-hidden" data-id="element-112">
      <div className="container mx-auto px-4" data-id="element-113">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-114">
          <span className="text-emerald-600 font-semibold tracking-wider uppercase text-sm" data-id="element-115">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mt-2 mb-6" data-id="element-116">
            Desinflama Primero
          </h2>
          <p className="text-lg text-stone-600" data-id="element-117">
            Decisiones rápidas, cero conteo, cero complicación.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-118">
          {/* Pillar 1 */}
          <div className="relative group" data-id="element-119">
            <div className="absolute inset-0 bg-emerald-50 rounded-3xl transform rotate-3 transition-transform group-hover:rotate-6" data-id="element-120"></div>
            <div className="relative bg-white border border-stone-200 p-8 rounded-3xl h-full shadow-sm" data-id="element-121">
              <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mb-6 text-emerald-700" data-id="element-122">
                <TrafficConeIcon className="h-6 w-6" data-id="element-123" />
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-124">
                Semáforo Anti-Inflamación
              </h3>
              <ul className="space-y-3 text-stone-600" data-id="element-125">
                <li className="flex items-center" data-id="element-126">
                  <span className="w-3 h-3 rounded-full bg-green-500 mr-3" data-id="element-127"></span>
                  Verde: Base de tu alimentación
                </li>
                <li className="flex items-center" data-id="element-128">
                  <span className="w-3 h-3 rounded-full bg-yellow-400 mr-3" data-id="element-129"></span>
                  Amarillo: Depende del momento
                </li>
                <li className="flex items-center" data-id="element-130">
                  <span className="w-3 h-3 rounded-full bg-red-500 mr-3" data-id="element-131"></span>
                  Rojo: Pausa por 21 días
                </li>
              </ul>
            </div>
          </div>

          {/* Pillar 2 */}
          <div className="relative group" data-id="element-132">
            <div className="absolute inset-0 bg-stone-100 rounded-3xl transform -rotate-3 transition-transform group-hover:-rotate-6" data-id="element-133"></div>
            <div className="relative bg-white border border-stone-200 p-8 rounded-3xl h-full shadow-sm" data-id="element-134">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 text-blue-700" data-id="element-135">
                <CalendarDaysIcon className="h-6 w-6" data-id="element-136" />
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-137">
                Menú 3 Fases 7/7/7
              </h3>
              <div className="space-y-4" data-id="element-138">
                <div className="border-l-4 border-emerald-200 pl-4" data-id="element-139">
                  <p className="font-semibold text-stone-900" data-id="element-140">
                    Días 1–7: Reinicio
                  </p>
                  <p className="text-sm text-stone-500" data-id="element-141">
                    Calma tu sistema digestivo
                  </p>
                </div>
                <div className="border-l-4 border-emerald-400 pl-4" data-id="element-142">
                  <p className="font-semibold text-stone-900" data-id="element-143">
                    Días 8–14: Estabiliza
                  </p>
                  <p className="text-sm text-stone-500" data-id="element-144">
                    Introduce variedad controlada
                  </p>
                </div>
                <div className="border-l-4 border-emerald-600 pl-4" data-id="element-145">
                  <p className="font-semibold text-stone-900" data-id="element-146">
                    Días 15–21: Acelera
                  </p>
                  <p className="text-sm text-stone-500" data-id="element-147">
                    Potencia los resultados
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Pillar 3 */}
          <div className="relative group" data-id="element-148">
            <div className="absolute inset-0 bg-amber-50 rounded-3xl transform rotate-3 transition-transform group-hover:rotate-6" data-id="element-149"></div>
            <div className="relative bg-white border border-stone-200 p-8 rounded-3xl h-full shadow-sm" data-id="element-150">
              <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center mb-6 text-amber-700" data-id="element-151">
                <SunIcon className="h-6 w-6" data-id="element-152" />
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-153">
                Protocolo AM/PM
              </h3>
              <p className="text-stone-600 mb-4" data-id="element-154">
                Rutina simple de mañana y noche para no improvisar.
              </p>
              <p className="text-sm text-stone-500 italic border-t border-stone-100 pt-4" data-id="element-155">
                "La estructura vence a la fuerza de voluntad."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}